// Tiny CSV helpers — no deps.

export const toCSV = (rows, headers) => {
    const esc = (v) => `"${String(v ?? '').replace(/"/g, '""')}"`;
    return [
        headers.join(','),
        ...rows.map((r) => headers.map((h) => esc(r[h])).join(',')),
    ].join('\n');
};

export const download = (csv, name) => {
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = name;
    a.click();
    URL.revokeObjectURL(url);
};
